module.exports = __webpack_public_path__ + "static/img/friendly-design.17226bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img-text/images/friendly-design.svg
// module id = qgjm
// module chunks = 26